"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_router_dom_1 = require("react-router-dom");
exports.useParamsKeys = (keys = ['id']) => {
    const values = {};
    const params = react_router_dom_1.useParams();
    keys.forEach((k) => {
        values[k] = params[values];
    });
    return values;
};
exports.useParamsKey = (key) => {
    const params = react_router_dom_1.useParams();
    return params[key];
};
//# sourceMappingURL=paramsKey.js.map